//src/types/Account/AccountEnums.ts

export enum GroundInstructorRatings {
  // ground instructors
  agi = 'Advanced Ground Instructor',
  bgi = 'Basic Ground Instructor',
  igi = 'Instrument Ground Instructor'
}

export enum PilotRatings {
  new = 'New',
  stud = 'Student',
  priv = 'Private',
  inst = 'Instrument',
  comm = 'Commercial',
  atp = 'ATP'
}

export enum InstructorRatings {
  cfi = 'CFI',
  cfii = 'CFII',
  mei = 'MEI'
}

export const AllRatings: (PilotRatings | InstructorRatings)[] = [
  ...Object.values(PilotRatings),
  ...Object.values(InstructorRatings)
]

export enum AircraftClass {
  sel = 'Single-Engine Land',
  ses = 'Single-Engine Sea',
  mel = 'Multi-Engine Land',
  mes = 'Multi-Engine Sea',
  ballg = 'Balloon-Gas',
  ballh = 'Balloon-Heater',
  glider = 'Glider',
  gryo = 'Gyroplane',
  helo = 'Helicopter',
  airship = 'Airship',
  powlift = 'Powered-Lift',
  taa = 'Technically Advanced Aircraft',
  complex = 'Complex'
}

export enum MedicalType {
  none = 'None',
  expired = 'Expired',
  first = 'First',
  second = 'Second',
  third = 'Third',
  basmed = 'Basic Med'
}

export enum Relationship {}

export interface MechanicCertificate {
  hasAirframe: boolean
  hasPowerplant: boolean
  hasIA: boolean
  certificateNumber: string
}

export function createMechanicCertificate(
  init: Partial<MechanicCertificate> = {}
): MechanicCertificate {
  return {
    hasAirframe: false,
    hasPowerplant: false,
    hasIA: false,
    certificateNumber: '',
    ...init
  }
}
